<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']">
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', deliveryNote?.id]">{{ deliveryNote?.number }}</a>
      </li>
      <li>
        <a>Abholzeit festlegen</a>
      </li>
    </ul>
  </div>
</div>

@if (formReady && deliveryNote) {
  <div class="page-content page-frame">
    <form
      class="page-sheet max-w-4xl mx-auto grid grid-cols-2 grid-flow-dense grid-rows-[auto_1fr]"
      [formGroup]="deliveryNotePickup"
      (submit)="savePickup()"
    >
      <section class="bm-card bm-card-sm">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Pakete</h2>
          <label class="bm-fieldset-label">
            <input class="b-checkbox" type="checkbox" [checked]="true" [disabled]="true" />
            <span>{{ deliveryNote.number }}</span>
          </label>
          @if (false) {
            <div>
              Weitere mögliche Pakete für diese Abholung:
              <hr class="m-1" />
            </div>
            <div formGroupName="other_deliveries">
              <div *ngFor="let other_note of otherDeliveries.controls; let i = index">
                <div class="d-flex align-items-center gap-1" [formGroupName]="i">
                  <mat-checkbox formControlName="is_checked" />
                  <a
                    target="_blank"
                    [routerLink]="['/', 'lieferscheine', other_note.value.id]"
                    class="g-link d-flex align-items-center gap-1"
                  >
                    <i class="fa fa-truck mr6"></i>
                    <span>{{ other_note.value.number }}</span>
                  </a>
                  <i class="fa fa-external-link text-muted"></i>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
      <section class="bm-card bm-card-sm col-1">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Abholung</h2>
          <div class="form-group d-flex gap-1">
            <label class="control-label">Carrier:</label>
            <p class="form-control-static bold">{{ deliveryNote.shipcloud_carrier }}</p>
          </div>
          @if (deliveryNote.shipcloud_carrier == "UPS") {
            <label class="bm-fieldset-label">Telefon</label>
            <input class="bm-input" type="text" formControlName="phone" />
          }

          <div class="bm-join w-full">
            <input
              class="bm-input bm-join-item w-full"
              [matDatepicker]="picker"
              formControlName="pickup_day"
              placeholder="MM/DD/YYYY"
              (click)="picker.open()"
            />
            <mat-datepicker #picker />
            <button class="bm-btn bm-join-item" (click)="picker.opened ? picker.close() : picker.open(); (false)">
              <span class="fa fa-calendar"></span>
            </button>
          </div>
          <div class="flex flex-row gap-2 items-center">
            <input class="bm-input w-full" type="time" formControlName="pickup_start" />
            <label for="pickup_end" class="col-sm-1 control-label pl-0 pr-0" style="text-align: center">
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </label>
            <input class="bm-input w-full" type="time" formControlName="pickup_end" />
          </div>
          <span>Mit der Abholung experimentieren bis keine Fehlermeldung kommt.</span>
        </div>
      </section>

      <section class="bm-card bm-card-sm row-span-2">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Abholung unter folgender Adresse</h2>
          <hawk-address-form [formGroup]="deliveryNotePickup" prefix="sender" [countries]="countries" />
        </div>
      </section>

      <div class="flex flex-row gap-2 items-center justify-end col-span-2 px-4">
        <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', deliveryNote.id]">Abbrechen</a>
        <label class="bm-fieldset-label">
          <input class="bm-checkbox" type="checkbox" formControlName="test" />Nur Test
        </label>
        <button [disabled]="deliveryNotePickup.invalid || submitting" class="bm-btn bm-btn-primary" type="submit">
          Abholzeit festlegen
        </button>
      </div>
    </form>
  </div>
}
